import { render, staticRenderFns } from "./ClaimsCalculator.vue?vue&type=template&id=94b6f0e8&"
import script from "./ClaimsCalculator.vue?vue&type=script&lang=js&"
export * from "./ClaimsCalculator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports